export default __webpack_public_path__ + "static/P_SearchThumb_IN-8815QFHD-f34075650d6a5800596420ade4df60b7.webp";